import gql from 'graphql-tag';

// Utilization metrics chart
const GET_RETAINER_UTILIZATION_METRICS = gql`
  query getRetainerUtilizationMetrics($input: ListInfoInput!) {
    getRetainerUtilizationMetrics(input: $input) {
      retainerUtilizations {
        contractName
        client {
          name
          accountId
        }
        offeringType
        totalAllotted
        consumed
        remaining
        utilization
      }
    }
  }
`;

// Overall summary table
const GET_RETAINER_SUMMARY_LIST = gql`
  query getRetainerSummaryList($listInfo: ListInfoInput!) {
    getRetainerSummaryList(input: $listInfo) {
      retainerUtilizations {
        contractId
        contractName
        client {
          name
          accountId
        }
        offeringType
        totalAllotted
        consumed
        remaining
        utilization
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        condition
        sort {
          attribute
          order
        }
      }
    }
  }
`;

// Retainer utilization cards
const GET_RETAINER_UTILIZATION = gql`
  query getRetainerUtilization($input: RetainerUtilizationInput) {
    getRetainerUtilization(input: $input) {
      contractName
      client {
        name
        accountId
      }
      offeringType
      totalAllotted
      consumed
      remaining
      utilization
    }
  }
`;

// Contracts dropdown list
const GET_RETAINER_CONTRACT_LIST = gql`
  query getRetainerContractList($input: RetainerContractListInput) {
    getRetainerContractList(input: $input) {
      contractId
      contractName
      contractType
    }
  }
`;

// Detailed consumption table
const GET_RETAINER_CONSUMPTION_LIST = gql`
  query getRetainerConsumptionList($input: RetainerConsumptionListInput) {
    getRetainerConsumptionList(input: $input) {
      items {
        itemId
        billDateTime
        revisedQuantity
        revisedAmount
        notes
        billStartDateTime
        workItem {
          workId
          subject
          displayId
          module
        }
        serviceCatalogItem {
          itemId
          name
          description
          category {
            categoryId
            name
          }
          itemType
          offerAsWorklogItem
          serviceTypeItem {
            itemId
            offeringType
          }
        }
      }
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
        condition
      }
    }
  }
`;

export {
  GET_RETAINER_UTILIZATION,
  GET_RETAINER_SUMMARY_LIST,
  GET_RETAINER_CONTRACT_LIST,
  GET_RETAINER_CONSUMPTION_LIST,
  GET_RETAINER_UTILIZATION_METRICS
};
